const getScrollbarWidth = () => window.innerWidth - document.documentElement.clientWidth

export const lockScroll = () => {
  const scrollbarWidth = getScrollbarWidth()
  document.documentElement.style.overflow = 'hidden'
  document.documentElement.style.paddingRight = `${scrollbarWidth}px`
}

export const unlockScroll = () => {
  document.documentElement.style.overflow = ''
  document.documentElement.style.paddingRight = ''
}



// WEBPACK FOOTER //
// ./src/utils/scrollLock.js